<template>
    <div>
        <o-table ref="tableList" :enable-delete="false"
                 :enable-new="false" :enable-view="false" :enable-edit="false" :title="$t('sandoz.contracts')"
                 :url="'/api/contracts?transformer=rep&include=next_apporver_users'"
                 :extra-row-button="[{icon: 'arrow-right'}]">
            <template slot="filter">
                <o-filter :default-filter="defaultFilter" v-on:filter-updated="(filters) => $refs.tableList.setFilters(filters)" :filter-cacheable="true">
                    <o-filter-select :items="years" :title="$t('sandoz.contract_year')" column="contract_year"></o-filter-select>
                    <o-filter-text :title="$t('sandoz.contract_no')" column="contract_no"></o-filter-text>
                    <o-filter-text :title="$t('sandoz.company_name')" column="company_name"  :prepend-percentage="true"></o-filter-text>
                    <o-filter-text :title="$t('sandoz.name')" column="name" :prepend-percentage="true"></o-filter-text>
                    <o-filter-text :title="$t('sandoz.address')" column="address" :placeholder="$t('sandoz.street_zip_city')"  :prepend-percentage="true"></o-filter-text>
                    <o-filter-select :items="status" :title="$t('sandoz.status')" column="status"></o-filter-select>
                    <o-filter-checkbox :items="salesPersons" :title="$t('sandoz.responsible_sales_person')" column="sales_person">
                    </o-filter-checkbox>
                    <o-filter-select :items="byApproval" :title="$t('sandoz.by_approval')" column="by_approval"></o-filter-select>
                </o-filter>
            </template>
            <template slot="head">
                <o-table-header column="customer_external_id">{{ $t('sandoz.customer_external_id') }}</o-table-header>
                <o-table-header :sortable="false">{{ $t('sandoz.company_name') }}</o-table-header>
                <o-table-header :sortable="false">{{ $t('sandoz.name') }}</o-table-header>
                <o-table-header :sortable="false">{{ $t('sandoz.address') }}</o-table-header>
                <o-table-header column="contract_year">{{ $t('sandoz.contract_year') }}</o-table-header>
                <o-table-header column="status">{{ $t('sandoz.status') }}</o-table-header>
                <o-table-header :sortable="false">{{ $t('sandoz.next_approver_role') }}</o-table-header>
                <o-table-header :sortable="false">{{ $t('sandoz.has_portal_login') }}</o-table-header>
            </template>
            <template slot="body" slot-scope="props">
                <td>{{props.item.customer_external_id}}</td>
                <td>{{props.item.masterAddress ? props.item.masterAddress.data.company_name : ''}}</td>
                <td>{{props.item.masterAddress ? props.item.masterAddress.data.name : ''}} {{props.item.masterAddress ? props.item.masterAddress.data.last_name : ''}}</td>
                <td>{{props.item.masterAddress ? props.item.masterAddress.data.street: ''}} {{props.item.masterAddress ? props.item.masterAddress.data.zip : ''}} {{props.item.masterAddress ? props.item.masterAddress.data.city : ''}}</td>
                <td>{{props.item.contract_year}}</td>
                <td>{{props.item.status}}</td>
                <td>
                    <template v-if="props.item.is_approved">
                        <template v-if="props.item.next_approver">
                            {{$t('sandoz.approved')}}
                            <a href="javascript:void(0);" @click="openApproverModel(props.item)">
                              <fa icon="info-circle" class="text-success"></fa>
                            </a>
                        </template>
                    </template>
                    <template v-else>
                        {{props.item.next_approver_role}}
                        <a href="javascript:void(0);" v-if="props.item.next_approver_role" @click="openApproverModel(props.item)">
                          <fa icon="info-circle"></fa>
                        </a>
                    </template>
                </td>
                <td>
                    <span class="badge badge-pill" :class="{'badge-success': props.item.has_portal_login, 'badge-secondary': !props.item.has_portal_login}">
                        {{props.item.has_portal_login ? $t('sandoz.yes') : $t('sandoz.no')}}
                    </span>
                </td>
            </template>
            <template slot="body-controls" slot-scope="props">
                <td class="text-right">
                    <!--
                    <b-dropdown variant="primary" class="invoice-dropdown">
                        <template #button-content><fa icon="file-invoice-dollar"/></template>
                        <b-dropdown-item-button @click="downloadInvoice(props.item, '_S1')">S1</b-dropdown-item-button>
                        <b-dropdown-item-button @click="downloadInvoice(props.item, '_S2')">S2</b-dropdown-item-button>
                        <b-dropdown-item-button @click="downloadInvoice(props.item)">Year</b-dropdown-item-button>
                    </b-dropdown>
                    -->
                    <b-btn variant="primary" @click="download(props.item)" v-if="canDownload (props.item) && props.item.status === 'Signed'">
                        <fa icon="download"/>
                    </b-btn>
                    <b-btn variant="primary" @click="salesforce(props.item)">
                        <fa :icon="['fab', 'salesforce']"/>
                    </b-btn>
                </td>
            </template>
        </o-table>
        <b-modal id="modal-approver" ref="approverModel" :ok-only="true" :ok-title="$t('core.close')"
                 :title="$t('sandoz.approver_details')" size="xl" @close="closeApproverModel">
            <template v-if="contract.next_approver">
                <div class="row justify-content-start pb-1 pt-1 font-weight-bold ml-1 mr-1">
                    <template v-for="n in 6">
                        <div class="col-sm pb-1 pl-0" v-if="('approver_' + '' + n) in contract && contract['approver_' + '' + n] && contract.next_approver >= n">
                            {{ $t('sandoz.approver_no', { number: n }) }}
                        </div>
                    </template>
                </div>
                <div class="row justify-content-start pb-1 pt-1 ml-1 mr-1">
                    <template v-for="n in 6">
                        <div class="col-sm pb-1 pl-0 mb-3" v-if="contract.next_approver >= n && ('approver_' + '' + n) in contract && contract['approver_' + '' + n]">
                            <div>{{ contract['approver_' + '' + n] }}</div>
                            <div v-if="contract.next_approver == n && !contract.is_approved">
                                <span class="badge badge-danger" >{{ $t('sandoz.pending') }}</span>
                            </div>
                            <template v-else>
                                <div v-if="('approval_date_' + '' + n) in contract && contract['approval_date_' + '' + n] && contract['approval_date_' + '' + n] !== '0000-00-00'">
                                    {{ contract['approval_date_' + '' + n] | formatDate }}
                                </div>
                                <div v-if="('approval_person_' + '' + n) in contract && contract['approval_person_' + '' + n]">
                                    {{ contract['approval_person_' + '' + n] }}
                                </div>
                            </template>
                        </div>
                    </template>
                </div>
                <template v-if="!contract.is_approved">
                    <div class="pl-0 pr-0 font-weight-bold">
                        {{ $t('sandoz.next_approver_users', {role: contract.next_approver_role}) }} <span class="badge badge-info" >{{ $t('sandoz.next_approver') }}</span>
                    </div>
                    <div class="row justify-content-start pb-1 pt-1 font-weight-bold ml-1 mr-1 mt-3">
                        <div class="col-sm pb-1 pl-0">
                            {{$t('core.name')}}
                        </div>
                        <div class="col-sm pb-1 pl-0 pr-0">
                            {{$t('core.email')}}
                        </div>
                        <div class="col-sm pb-1 pl-0 pr-0">
                            {{$t('core.phone')}}
                        </div>
                        <div class="col-sm pb-1 pl-0 pr-0">
                            {{$t('core.status')}}
                        </div>
                    </div>
                    <template v-if="contract.next_approver_users && contract.next_approver_users.data && Object.keys(contract.next_approver_users.data).length">
                        <div class="row justify-content-start border-top pb-1 pt-1 ml-1 mr-1" v-for="user in contract.next_approver_users.data.filter(u => contract.status !== 'Draft' || u.active)">
                            <div class="col-sm pb-1 pl-0">
                                {{ user.name }}
                            </div>
                            <div class="col-sm pb-1 pl-0 pr-0">
                                {{ user.email }}
                            </div>
                            <div class="col-sm pb-1 pl-0 pr-0">
                                {{ user.phone }}
                            </div>
                            <div class="col-sm pb-1 pl-0 pr-0">
                                <span class="badge" :class="user.active ? 'badge-success': 'badge-danger'">
                                    {{ user.active ? $t('core.active') : $t('core.inactive') }}
                                </span>
                            </div>
                        </div>
                    </template>
                    <template v-else>
                        <div class="row justify-content-start border-top pb-1 pt-1 ml-1 mr-1">
                            <div class="col-sm pb-1 pl-0">
                                {{ $t('sandoz.approver_not_found') }}
                            </div>
                        </div>
                    </template>
                </template>
            </template>
            <template v-else>
                <div class="row justify-content-start pb-1 pt-1 ml-1 mr-1">
                    <div class="col-sm pb-1 pl-0">
                      {{ $t('sandoz.not_need_to_approve') }}
                    </div>
                </div>
            </template>
        </b-modal>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import axios from 'axios'
import { contractYears, getCurrentYear } from '../../utils/contractYear'

export default {
    data: () => ({
        status: [],
        years: [],
        defaultFilter: [],
        contract: [],
        salesPersons: [],
        byApproval: []
    }),
    computed: {
        ...mapGetters({
            user: 'auth/user'
        })
    },
    created () {
        this.years = contractYears()

        this.status = [
            {value: 'Draft', text: this.$i18n.t('sandoz.draft')},
            {value: 'Planned', text: this.$i18n.t('sandoz.planned')},
            {value: 'Committed', text: this.$i18n.t('sandoz.committed')},
            {value: 'Signed', text: this.$i18n.t('sandoz.signed')},
            {value: 'Lost', text: this.$i18n.t('sandoz.lost')},
            {value: 'Cancelled', text: this.$i18n.t('sandoz.cancelled')},
            {value: 'ZeroInvest', text: this.$i18n.t('sandoz.zero_invest')}
        ]

        this.getContractSalesPerson()

        this.byApproval = [
            {value: 'approval_in_progress', text: this.$i18n.t('sandoz.approval_in_progress')},
            {value: 'approval_completed', text: this.$i18n.t('sandoz.approval_completed')}
        ]

        this.defaultFilter = [{
          column: 'contract_year',
          displayValue: getCurrentYear(),
          title: this.$i18n.t('sandoz.contract_year'),
          value: getCurrentYear()
        }]
    },
    methods: {
        canDownload (contract) {
            if (this.hasPermission(['GET api/contracts/{id}/pdf']) && contract) {
                if (contract.is_kam) {
                    return !!this.user.is_kam_user
                }
                return true
            }
            return false
        },
        download(contract) {
            axios.get('/api/contracts/' + contract.id + '/pdf', { responseType: 'arraybuffer' })
                .then((response) => {
                    require('downloadjs')(response.data,
                        contract.customer_external_id + '.pdf', 'application/pdf'
                    )
                }).catch((error) => {
                    if(error.response.status === 404) {
                        this.$notify({
                            title: this.$i18n.t('core.error'),
                            text: this.$i18n.t('sandoz.file_not_found'),
                            type: 'error'
                        })
                    } else {
                        this.$notify({
                          title: this.$i18n.t('core.error_alert_title'),
                          text: this.$i18n.t('core.error_alert_text'),
                          type: 'error'
                        })
                    }
            })
        },
        salesforce(contract) {
            window.open('https://sz-scout01.lightning.force.com/lightning/r/Account/' + contract.contact_code + '/view')
        },
        hasPermission(item) {
            let result = true
            let permissions = item
            let user = this.user
            if (!user.is_super_user && permissions) {
                permissions.forEach((permission) => {
                    if (!user.routePermissions.includes(permission)) {
                      result = false
                    }
                })
            }
            return result
        },
        downloadInvoice (contract, payment = '') {
            let param = '1/12'
            if (payment === '_S1') {
                param = '1/6'
            } else if (payment === '_S2') {
                param = '7/12'
            } else if (payment === '_Q1') {
                param = '1/3'
            } else if (payment === '_Q2') {
                param = '4/6'
            } else if (payment === '_Q3') {
                param = '7/9'
            } else if (payment === '_Q4') {
                param = '10/12'
            }

            let name = contract.contract_no
            if(contract.masterAddress && contract.masterAddress.data) {
                let result = contract.masterAddress.data.company_name.substr(0, 3)
                if (result === 'FMH') {
                  name = contract.contract_no + '-' + contract.masterAddress.data.name + ' ' + contract.masterAddress.last_name + '-' + contract.masterAddress.city
                } else {
                  name = contract.contract_no + '-' + contract.masterAddress.data.company_name + '-' + contract.masterAddress.data.city
                }
            }

            axios.get('/api/sandoz/contracts/' + contract.id + '/invoice/' + param, { responseType: 'arraybuffer' })
                .then((response) => {
                    require('downloadjs')(response.data,
                        name + '' + payment + '.pdf', 'application/pdf'
                    )
                }).catch((error) => {
                    if(error.response.status === 404) {
                      this.$notify({
                        title: this.$i18n.t('core.error'),
                        text: this.$i18n.t('sandoz.file_not_found'),
                        type: 'error'
                      })
                    } else {
                      this.$notify({
                        title: this.$i18n.t('core.error_alert_title'),
                        text: this.$i18n.t('core.error_alert_text'),
                        type: 'error'
                      })
                    }
            })
        },
        openApproverModel(contract) {
            this.contract = contract
            this.$refs.approverModel.show()
        },
        closeApproverModel() {
            this.contract = null
            this.$refs.approverModel.hide()
        },
        getContractSalesPerson () {
            var self = this
            axios.get('/api/verifications/contract_sales_persons').then((response) => {
                if (response.data.length) {
                    response.data.forEach(function (person) {
                        self.salesPersons.push({ value: person, text: person })
                    })
                }
            }).catch((error) => {
                console.error(error)
            })
        }
    }
}
</script>

<style lang="scss">
.invoice-dropdown{
  .dropdown-menu{
    min-width: auto;
    padding: 2px;
  }
  .dropdown-menu.show {
    display: inherit;
  }
}
.mw-52 {
  min-width: 52px;
}
</style>
